import { observable, tap } from '@trpc/server/observable';
import superjson from 'superjson';

function devtoolsLink(opts = {}) {
  const {
    enabled = true
  } = opts;

  if (enabled && typeof window === "object") {
    window.__TRPC_CLIENT_HOOK__ = true;
  }

  function sendMessageToDevtools(payload) {
    if (typeof window === "object") {
      window.postMessage({
        source: "trpcDevtoolsLink",
        payload: superjson.stringify(payload)
      }, "*");
    }
  }

  return () => {
    return ({
      op,
      next
    }) => {
      return observable(observer => {
        enabled && sendMessageToDevtools(op);
        const requestStartTime = Date.now();

        function handleResult(result) {
          const elapsedMs = Date.now() - requestStartTime;
          enabled && sendMessageToDevtools({ ...op,
            result,
            elapsedMs
          });
        }

        return next(op).pipe(tap({
          next(result) {
            handleResult(result);
          },

          error(result) {
            handleResult(result);
          }

        })).subscribe(observer);
      });
    };
  };
}

export { devtoolsLink };
